import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';

@Injectable()
export class LocationsAnalytics extends AnalyticsBase {
  public readonly namespace: string = 'Locations';
  public readonly requireViewContext: boolean = true;

  public trackCreateNew(): void {
    this.track('CreateNew');
  }

  public trackEditLocation(): void {
    this.track('EditLocation');
  }

  public trackMergeLocations(): void {
    this.track('MergeLocations');
  }

  public trackAssignLocation(): void {
    this.track('AssignLocation');
  }
}
